import React from 'react';
import { Text } from 'basis';
import { applicationReasonOptionsNZV2 } from '../_constants';

const applicationReasonValues = applicationReasonOptionsNZV2.map(({ value }) => value);

export const generateOverviewFormConfig = ({ TermAndConditions, trackApplicationReasonChange }) => [
  {
    component: 'RadioTile',
    name: 'applicationReason',
    label: 'Tell us how you will use your Gem Visa',
    testId: 'application-reason',
    options: applicationReasonOptionsNZV2,
    showCircles: true,
    columns: 1,
    onChange: trackApplicationReasonChange,
    validate: value => (value === '' ? 'Please make a selection' : null),
  },
  {
    component: 'CustomComponent',
    children: () => <Text>The Gem Visa credit card should not be used for other purposes.</Text>,
  },
  {
    component: 'CustomComponent',
    children: () => (
      <Text>
        When applying for a Gem Visa you are applying for a revolving credit contract (a general purpose credit card).
        When applying for this credit, you confirm that you require the credit on an ongoing basis.
      </Text>
    ),
  },
  {
    component: 'Checkbox',
    name: 'consentGiven',
    label: '',
    testId: 'consent-given',
    children: <TermAndConditions />,
    validate: value =>
      value === false ? 'To proceed, check the box to confirm that you agree to the terms above' : null,
  },
];

export const isValidOverview = formData => {
  const isValid =
    Object.keys(formData.state.errors).length === 0 &&
    applicationReasonValues.includes(formData.state.values.applicationReason) &&
    formData.state.values.consentGiven === true;
  return !!isValid;
};
